module.exports = __webpack_public_path__ + "static/img/rys3.acf2ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rys3.jpg
// module id = sx8C
// module chunks = 1